module.exports = __webpack_public_path__ + "img/icon2.62541361.svg";